<div [class]="customClass">
  <ng-container *ngIf="isRole">
    <ng-content></ng-content>
  </ng-container>
</div>
